export function MyRound10(val: number) {
  return Math.floor(val / 1000) * 1000;
}
